export default __webpack_public_path__ + "static/media/retake-audio.4b1ebe32.svg";